/*
 * @Author: JamesWong
 * @Description: 3.2小票配置
 * @Date: 2019-01-04 14:59:12
 * @Last Modified by: JamesWong
 * @Last Modified time: 2019-01-07 11:40:50
 */
export default {
  confirm: 'Confirm',
  cancel: 'Cancel',
  channel: 'Channel',
  order: 'Order',
  templateName: 'Template Name',
  added: 'Added',
  enterTemplateName: 'Please enter template name',
  Operation: 'Operation',
  edit: 'Edit',
  filters: 'Channel Type Filters',
  defaults: 'Defaults',
  review: 'Review',
  delete: 'Delete',
  channelNumber: 'Channel No.',
  salesCreateReciept: 'Sales',
  createDeposit: 'Deposit',
  account: 'Account',
  pleaseSelectAgain: 'Please select again',
  channelRecipetConfiguration: 'Channel Recipet Configuration',
  recipetTemplate: 'Recipet Template',
  depositTemplate: 'Deposit Template',
  numberTemplate: 'Number Template',
  channelType: 'Channel Type',
  recipetStyle: 'Recipet Style',
  saleVersion: 'Sale Channel/Customer Version',
  reprintVersion: 'Reprint Channel/Customer Version',
  selectChannelSettings: 'Select Channel Settings',
  setChannelType: 'Set by Channel Type',
  setbyAccount: 'Set by Account',
  channelSelected: 'Channel Selected',
  SaleNum: 'Channel/Customer Version No.',
  ReprintNum: 'Reprint-Channel/Customer Version No.',
  selectChannel: 'Select Channel',
  saleRecipetNumberTemplate: 'Sale Recipet Number Template',
  depositRecipetNumberTemplate: 'Deposit Recipet Number Template',
  reprintNumberTemplate: 'Reprint Number Template',
  businessType: 'Business Type',
  number: 'Number',
  selectTips: 'Please select the channel first to set the recipet style',
  setTips: 'Setted!',
  styleWarn: "Please select 'Recipet Style' template",
  sellWarn: "Please select 'Sales-Channel/Customer Version No.' template",
  sellWarn2: "Please select 'Deposit-Channel/Customer Version No.' template",
  reprintWarn: "Please select 'Reprint-Channel/Customer Version No.' template",
  noset: 'No Set Channel Type',
  select: 'selected',
  numTypeSale: 'Sale-Channel/Customer Version',
  numTypeReprint: 'Reprint-Channel/Customer Version',
  deleteReceiptModel: 'Delete Recipet Template',
  deleteTips: 'Delete the recipet template?',
  addtips: 'Added',
  edittips: 'Edited'
}


// WEBPACK FOOTER //
// ./src/i18n/en/newSlip.js